import { contentBlockSurface } from 'shared/assets/styles';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: ${({ theme }) =>
    theme.isMobile ? `calc(100dvh - 6.4rem)` : '100dvh'};
  width: 100%;
`;

export const Main = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  padding: ${({ theme }) =>
    `${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(2)}`};
  min-width: 0;
`;

export const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  ${contentBlockSurface};

  overflow: hidden;
`;

export const SidePanel = styled.div<{ $open: boolean }>`
  height: 100%;

  ${({ $open, theme }) =>
    $open &&
    css`
      padding: ${`${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(0.25)}`};
    `};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      display: none;
    `}
`;

export const SidePanelContent = styled.div<{ $open: boolean }>`
  height: 100%;

  ${({ $open }) =>
    $open &&
    css`
      ${contentBlockSurface};
    `};
`;

// Clips to the surface radius unconditionally, so the close animation stays round-cornered.
export const SidePanelContentClip = styled.div`
  height: 100%;

  border-radius: ${({ theme }) => theme.spacing(4)};
  overflow: hidden;
`;
